// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-1 {
    width: 85%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--margin-bottom-mobile);
    margin-top: 250px;
}

.section-1-heading {
    font-size: 5rem;
    color: '#20303F';

    & p {
        margin: 0;
    }
}

.section-1-buttons {
    display: flex;
    margin-bottom: 2.5rem;
    gap: 1rem
}

.section-1-bottom {
    font-size: var(--font-size1);
    border-top: 1px solid black;
    padding-top: 1rem;
}

.bold-heading {
    font-weight: bolder;
}

.section-1-desc {
    font-size: 2.2rem;
}

.partners {
    display: flex;
    gap: 1rem;
}

@media screen and (min-width:300px) and (max-width:490px) {
    .section-1 {
        flex-direction: column;
        gap: 2rem;
        width: 95%;
        margin-top: 0px;
        margin-bottom: 3rem;
    }

    .section-1-heading {
        font-size: 2.625rem;
    }

    .section-1-desc {
        font-size: 1.125rem;
        width: 60%;
    }

    .section-1-bottom {
        font-size: 1rem;
    }

    .section-1-right img {
        width: 93%;
    }
}

@media screen and (min-width:601px) and (max-width:840px) {
    .section-1 {
        width: 90%;
        justify-content: space-between;
        margin-top: 0px;
    }

    .section-1-heading {
        font-size: 2rem;
    }

    .section-1-desc {
        font-size: 1rem;
    }

    .section-1-bottom {
        font-size: 0.8rem;
    }

    .section-1-right img {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section1.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB;QACI,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,UAAU;QACV,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".section-1 {\r\n    width: 85%;\r\n    margin: auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: var(--margin-bottom-mobile);\r\n    margin-top: 250px;\r\n}\r\n\r\n.section-1-heading {\r\n    font-size: 5rem;\r\n    color: '#20303F';\r\n\r\n    & p {\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n.section-1-buttons {\r\n    display: flex;\r\n    margin-bottom: 2.5rem;\r\n    gap: 1rem\r\n}\r\n\r\n.section-1-bottom {\r\n    font-size: var(--font-size1);\r\n    border-top: 1px solid black;\r\n    padding-top: 1rem;\r\n}\r\n\r\n.bold-heading {\r\n    font-weight: bolder;\r\n}\r\n\r\n.section-1-desc {\r\n    font-size: 2.2rem;\r\n}\r\n\r\n.partners {\r\n    display: flex;\r\n    gap: 1rem;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .section-1 {\r\n        flex-direction: column;\r\n        gap: 2rem;\r\n        width: 95%;\r\n        margin-top: 0px;\r\n        margin-bottom: 3rem;\r\n    }\r\n\r\n    .section-1-heading {\r\n        font-size: 2.625rem;\r\n    }\r\n\r\n    .section-1-desc {\r\n        font-size: 1.125rem;\r\n        width: 60%;\r\n    }\r\n\r\n    .section-1-bottom {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .section-1-right img {\r\n        width: 93%;\r\n    }\r\n}\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n    .section-1 {\r\n        width: 90%;\r\n        justify-content: space-between;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .section-1-heading {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .section-1-desc {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .section-1-bottom {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .section-1-right img {\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
